
<template>
  <div id="order-payment">
    <el-dialog class="order-payment-dialog" :close-on-click-modal="false" custom-class="lg-dialog order-payment" append-to-body :visible="paymentVisible" :before-close="hideAdd" :title="'收银台'">
      <!-- 订单信息 -->

      <div class="lay-order">
        <h4 class="title"><i class="el-icon-circle-check"></i>{{$t('portal.ti-jiao-ding-dan-qing-zhi-fu')}}</h4>
        <p class="total">{{$t('portal.ying-fu-jine')}}<span class="currency_sign">¥</span><span class="number">{{ formatMoney(orderInfo.total,true) }}</span></p>
        <div class="order_des">
          <!-- 贷款小计：{{ formatMoney(orderInfo.total) }}，费用小计：{{ formatMoney(orderInfo.total) }} -->
          <p>{{$t('portal.gong')}} {{orderInfo.list.length}} {{$t('portal.bi-ding-dan')}}</p>
          <el-tooltip class="item" effect="light" placement="top">
            <div slot="content" v-html="chainStr(orderInfo.list)"></div>
            <p v-html="chainStr(orderInfo.list)" class="order_show"></p>
          </el-tooltip>
        </div>
        <!-- 备注 -->
        <el-form class="lay-remark" :model="remarkForm" ref="remarkFormDom" label-width="60px">
          <el-form-item prop="remark" :label="$t('common.remark')">
            <el-input v-model="remarkForm.remark" type="textarea" size="small" :maxlength="200" resize="none" :autosize="{ minRows: 4 }" :placeholder="$t('portal.qing-shu-ru-200-zi-yi-nei')"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <!-- 支付方式 -->
      <div class="lay-pay" v-loading="methodLoading">
        <h4 class="title">{{$t('portal.qing-xuan-ze-zhi-fu-fang-shi')}}</h4>
        <!-- 平台单 -->
        <div class="pay_type" v-if="!batchPay && (orderType ==='platform' || orderType === 'self-operated')">
          <div v-for="(item,key) in payType" :key="key" :class="[item.payType === activePayMethod ? 'active' : '']" class="pay_type_item platform" :id="item.id" @click="changePayType(item.id)">
            {{ item.name }}
          </div>
          <div v-show="showYeePay" class="pay_type_item platform" :class="[activePayMethod === 'yeepay' ? 'active' : '']" @click="changePayType('yeepay')">扫码支付</div>
        </div>
        <!-- 非平台单 -->
        <div class="pay_type" v-else>
          <div v-for="(item,key) in payType" :key="key" :class="[item.payType === activePayMethod ? 'active' : '']" class="pay_type_item" :id="item.id" @click="changePayType(item.id)">
            <img :src="item.img" :alt="item.name">
          </div>
          <div v-show="showYeePay" class="pay_type_item" :class="[activePayMethod === 'yeepay' ? 'active' : '']" @click="changePayType('yeepay')">
            <img src="~~/common/assets/img/yeepay.png" style="width:120px;height:40px;">
          </div>
        </div>
        <div class="pay_message wallet" :style="{height: showPWD ? '131px' : '235px'}" v-show="activePayMethod === 'wallet'">
          <el-radio-group v-model="activeWalletType" @change="getCardInfo">
            <el-radio :label="item.id" v-for="item in walletList" :key="item.id" :class="item.id">
              <template v-if="item.cardInfo.card_id && item.id === activeWalletType && item.id==='ICP'">
                <div class="card">
                  <div class="card_box">
                    <!-- <span class="card_name"><img class="logo" :src="Logo" alt="">{{item.cardInfo.card_type}}</span>
                    <span>{{item.cardInfo.card_number}}</span> -->
                    <p class="account_name">{{item.cardInfo.card_type}}</p>
                    <p class="card_name">{{item.cardInfo.card_name}}</p>
                    <p>{{item.cardInfo.card_number}}</p>
                  </div>
                </div>
                <div class="balance">
                  <!-- 记账可用等于之前的资产+信用 -->
                  <p class="amount">{{$t('portal.ji-zhang-ke-yong')}}：<span class="num">{{ formatMoney(item.cardInfo.icd_assets+item.cardInfo.icw_assets) }}</span></p>
                </div>
                <!-- <div class='balance'>
                  <el-form class="lay-balance" :model="balanceForm" ref="balanceForm" :rules="balanceRule" label-width="70px">
                    <el-form-item class="form-item-balance" prop="asset_amount" label="资产：">
                      <el-input v-model="balanceForm.asset_amount" size="small" :maxlength="30" placeholder="请输入资产">
                      </el-input>
                    </el-form-item>
                  </el-form>
                  //这里的余额指芯币可用余额
                  <p class="amount">可用余额：<span class="num">{{ formatMoney(item.cardInfo.icd_assets) }}</span></p>
                </div>
                <div class="credit">
                 //这里的余额指信用可用余额
                  <p><span class="credit-num">信用：{{ formatMoney(credit_amount) }}，</span><span class="amount">可用余额：<span class="num">{{ formatMoney(item.cardInfo.icw_assets) }}</span></span></p>
                </div> -->
              </template>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="pay_message hxb" style="display:flex;"  :style="{height: showPWD ? '131px' : '235px','align-items':isHxCard ?'flex-start':'center'}" v-show="activePayMethod === 'hxb'">
          <!-- 华夏银行展示 -->
          <template v-if="isHxCard">
            <div class="card" style="width:210px;">
              <div class="card_box hxb_card">
                <p class="account_name">{{$t('portal.hua-xia-zhang-hu')}}</p>
                <p class="card_name">{{shopCardMessage.card_name}}</p>
                <p>{{shopCardMessage.card_number}}</p>
              </div>
            </div>
            <div class="balance" style="position:relative;margin-top:20px">
              <p class="amount uni">{{$t('portal.gong-si-ke-yong')}}：<span class="num">{{ formatMoney(haxiaCradMessage.icd_assets) }}</span></p>
              <p class="amount" v-if="showPayAssets">{{$t('portal.jiao-yi-ke-yong')}}：<span class="num">{{ formatMoney(activeWallet.cardInfo.icd_assets + activeWallet.cardInfo.icw_assets) }}</span></p>
              <div class="prompt_text" style="position:absolute;top:28px;margin:0;">
                <p class="list">{{$t('portal.gong-si-yu-e-bu-zu')}}</p>
                <p class="list">{{$t('portal.hua-xia-yin-xing')}}</p>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="card card_not_open">
              <div class="card_box hxb_card">
                <p class="account_name">{{$t('portal.hua-xia-zhang-hu')}}</p>
                <p class="card_name"></p>
                <p>{{$t('portal.wei-kai-tong')}}</p>
              </div>
            </div>
            <p class="hxb_prompt">{{$t('portal.hua-xia-wei-kai-tong')}}</p>
          </template>
        </div>
        <div class="pay_message advance_payment" :style="{height: showPWD ? '131px' : '235px'}" v-show="activePayMethod === 'advance_payment'">
          <div class="card">
            <div class="card_box hxb_card">
              <p class="account_name">{{activeWallet.cardInfo.card_type}}</p>
              <p class="card_name">{{activeWallet.cardInfo.card_name}}</p>
              <p>{{activeWallet.cardInfo.card_number}}</p>
            </div>
          </div>
          <div class="balance">
            <p class="amount uni">{{$t('portal.dian-fu-ke-yong')}}<span class="num">{{ formatMoney(activeWallet.cardInfo.iou_assets) }}</span></p>
            <p class="amount" v-if="showPayAssets">{{$t('portal.jiao-yi-ke-yong')}}：<span class="num">{{ formatMoney(activeWallet.cardInfo.icd_assets + activeWallet.cardInfo.icw_assets) }}</span></p>
          </div>
        </div>
        <div class="pay_message wangyin" v-show="activePayMethod === 'wangyin'">
          <div
          class="contentAbsFixed"
          v-if="step===2"
          v-loading="true"
          element-loading-text="支付中，请稍后..."
          element-loading-background="rgba(255, 255, 255, 0.8)">
          </div>
          <ul>
            <li v-for="v in bankNames" :key="v.src">
              <div class="pointerBox" :class="{active: curBank === v.src}" @click="chooseBank(v)">
                <img :src="bankImgs[v.src]" alt="">
                <span>{{ v.label }}</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="pay_message bankTo" v-if="activePayMethod === 'bankTo'">
          <div class="bankTo" v-if="step===2">
            <div class="tip1">* 以下转账信息均必填且务必保持一致</div>
            <ul>
              <li v-for="v in bankToList" :key="v.id" style="width:390px;">
                <div class="msg">
                  <span class="label">{{ v.label }}：</span>
                  <span class="value">{{ bankToData[v.id] }}</span>
                </div>
                <span class="copy"  @click="copy(bankToData[v.id])">复制</span>
              </li>
            </ul>
            <div class="tip2">*分支行请务必选择<span>易宝支付-备付金账户</span>如无该选项请不要转账</div>
          </div>
          <template v-else>
            <div class="tip1" >* 转账注意事项</div>
            <ul>
              <li>
                1、为避免资金损失，请仔细阅读收款信息
              </li>
              <li>
                2、汇款账户全称需为 XXX（卖方对应的佣金账户全称）
              </li>
              <li style="justify-content:flex-start">
                3、请务必先点击下方 “<span style="color:#ea5728;padding:0 2px;margin:0">下一步</span>” 按钮获取转账信息后，再转账
              </li>
            </ul>
          </template>
        </div>
        <div class="pay_message yeepaycode" v-if="activePayMethod === 'yeepay'">
          <!-- <div class="nextStepFixed" v-if="step === 2"> -->
            <Code2pay v-if="code2PayVisible" style="margin-top:8px;" ref="code2Pay" @hide="payResult => hideVisible('yeepay', payResult)" :propData="code2Data"></Code2pay>
          <!-- </div> -->
          <!-- <template v-else>
            <div class="tip1">* 支付注意事项</div>
            <ul>
              <li>
                1、 二维码支付为聚合码，支持微信、支付宝、云闪付三种方式
              </li>
              <li>
                2、用户可任意使用微信或支付宝，或者开通了云闪付的手机银行进行扫码支付
              </li>
              <li style="justify-content:flex-start">
                3、点击<span style="color:#ea5728;padding:0 2px;margin:0">下一步</span>按钮，可扫码支付
              </li>
            </ul>
          </template> -->
        </div>
      </div>
      <!-- 支付密码 -->
      <el-form class="lay-password" :model="passwordForm" ref="passwordFormDom" :rules="paymentRule" :show-message="false" label-width="90px" v-show="showPWD">
        <el-form-item class="form-item-password" prop="password" :label="$t('login.password')">
          <el-input v-model="passwordForm.password" type="password" size="small" :maxlength="30" :placeholder="$t('portal.qing-shu-ru-zhi-fu-mi-ma')"></el-input>
          <span class="forget" @click="showVerifyDialog">{{$t('login.forget_password')}}</span>
          <p v-if="activePayMethod === 'hxb'" class="password_prompt">{{$t('portal.qing-shu-ru-nin-de-jiao-yi-zhang-bu-zhi-fu-mi-ma')}}</p>
          <p v-else class="password_prompt">{{$t('portal.qing-shu-ru-nin-de-jiao-yi-zhang-bu-zhi-fu-mi-ma')}}</p>
        </el-form-item>
      </el-form>
      <!-- 底部按钮 -->
      <div class="lay-footer">
        <template v-if="['wangyin','yeepay','bankTo'].includes(activePayMethod)">
          <el-button class="btn-pay" type="primary" size="large" v-if="step === 1 && activePayMethod !== 'yeepay'" :disabled="isPaymentDisabled" @click="selectStep(2)" :loading="dataLoading">下一步</el-button>
          <el-button class="btn-pay" type="primary" size="large" v-if="step === 2 && activePayMethod !== 'yeepay'" @click="selectStep(1)" :loading="dataLoading">上一步</el-button>
          <el-button class="btn-pay" type="primary" size="large" v-if="step === 2 && activePayMethod === 'bankTo'" @click="hideAdd('zhuan-done')">我已完成转账</el-button>
        </template>
        <el-button v-else class="btn-pay" type="primary" size="large" @click="submitPayment" :loading="dataLoading">立即支付</el-button>
        <!-- <p v-show="payWithoutPassword&&activePayMethod !== 'online'" class="btn-pay-note">您已开启免密支付，如需调整请前往商户-设置中调整</p> -->
      </div>
      <!-- 忘记密码三弹窗 -->
      <getVerifyCode v-bind="forgetData.verifyData" @next="verifyPhoneOk" @hide="hideVerify"></getVerifyCode>
      <setPasswordDialog v-bind="forgetData.setNewData" @save="setNewPsd" @hide="hideSet"></setPasswordDialog>
      <resultDialog v-bind="forgetData.resultData" @hide="hideResult"></resultDialog>
      <!-- 微信支付弹窗 -->
      <WechartPayDialog :visible="wechartPayVisible" @hide="payResult => hideVisible('wechat', payResult)" :propData="WechartData"></WechartPayDialog>
      <!-- 支付宝支付弹窗 -->
      <AliPayDialog :visible="alipayPayVisible" @hide="payResult => hideVisible('alipay', payResult)" :propData="AlipayData"></AliPayDialog>
      <!-- 充值支付结果弹窗 -->
      <template>
        <OrderPaymentResult :visible="resultVisible" @hide="hideOrderPaymentResult" :payMessage="payMessage" :showFooter="showFooter" v-if="payMethod === 'single'" :postOrderId="postOrderId"/>
        <SeriePaymentResultNew :visible="resultVisible" @hide="hideOrderPaymentResult" :payMessage="payMessage" :showFooter="showFooter" v-else-if="payMethod === 'serie'"/>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {translateI18n} from '~/common/utils/i18n-helper'
import { icFilters } from '~/common/plugins/ic-utils.js';
import { offlinePayeeInfo, paymentField, paymentRule, apiGetBillDetail, apiGetPaymentCardInfo, apiGetCardDetail, apiSetCardPassword, apiRechargeMoney, apiSubmitPayment } from '~/common/components/dialog/payDialog/config.js';
import BaseInfo from '~/common/components/detail/BaseInfo.vue';
import getVerifyCode from '~/common/components/setPassword/get_verify_code.vue';
import setPasswordDialog from '~/common/components/setPassword/set_password_dialog.vue';
import resultDialog from '~/common/components/setPassword/result_dialog.vue';
import WechartPayDialog from '~/common/components/dialog/WechartPayDialog.vue';
import AliPayDialog from '~/common/components/dialog/AlipayDialog.vue';
import { regexMoneyNumber } from '~/common/utils/validate';
import Alipay from '~/common/assets/img/aliPay_pay_logo.png';
import Logo from '~/common/assets/img/logo.png';
import WechartPay from '~/common/assets/img/weChart_pay_logo.png';
import XinPay from '~/common/assets/img/pay4.png';
import HuaXia from '~/common/assets/img/pay1.png';
import AdvancePayment from '~/common/assets/img/pay2.png';
import OrderPaymentResult from '~/common/components/dialog/payDialog/PaymentResult.vue';
import SeriePaymentResultNew from '~/common/components/dialog/payDialog/SeriePaymentResultNew.vue';
import { multiplication } from '~/common/utils/index';
import { storage } from '~/common/utils/storage';
import { mapState } from 'vuex';
import Code2pay from '../Code2pay.vue'
import {trackEventApi} from '~/common/utils/track'
export default {
  name: 'orderPayment',
  components: {
    BaseInfo,
    getVerifyCode,
    setPasswordDialog,
    resultDialog,
    WechartPayDialog,
    AliPayDialog,
    OrderPaymentResult,
    SeriePaymentResultNew,
    Code2pay
  },
  props: {
    payConfig: {
      type: Object,
      default: () => {
        return {
          payment_term_title:'', // TT cod net
          payment_methods:[],
          payment_methods_default:'',
          bank_name: ''
        }
      }
    },
    payNumber:{
      type: String,
      default: ''
    },
    paymentVisible: {
      type: Boolean,
      default: false
    },
    payUrl: {
      type: String,
      default: apiSubmitPayment
    },
    orderDetailUrl: {
      type: String,
      default: apiGetBillDetail
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    accountType: {
      //业务单类型，销售:S，采购：P
      type: String,
      default: ''
    },
    orderId: [String, Array],//订单ID
    batchPay:{
      type:Boolean,
      default: () => false
    }
  },
  data() {
    let checkPrice = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(translateI18n('portal.qing-shu-ru-zi-chan')));
        return;
      }
      if (value < 0) {
        callback(new Error(translateI18n('portal.zi-chan-bu-neng-xiao-yu-0')));
        return;
      }
      if (value && !regexMoneyNumber(value, 2)) {
        callback(new Error(translateI18n('portal.qing-shu-ru-zheng-que-de-zi-chan-ge-shi')));
        return;
      }
      if (this.activeWallet.cardInfo.icd_assets < 0 && Number(value) !== 0) {
        //资产是负数的时候，输入金额只能是0
        callback(new Error(translateI18n('portal.mei-you-ke-yong-yu-e')));
        return;
      }
      // 资产非负数时
      if (this.activeWallet.cardInfo.icd_assets >= 0 && multiplication(value, 10000) > this.activeWallet.cardInfo.icd_assets) {
        callback(new Error(translateI18n('portal.shu-ru-zi-chan-bu-neng-da-yu-zi-chan-yu-e')));
        return;
      }
      callback();
    };

    return {
      step:1,
      payFlag1:false,
      bankToDone: '-1',
      payFlag:false,
      bankToList: [
        {label: '收款户名',id: 'receive_name'},
        {label: '收款账号',id: 'receive_account_no'},
        {label: '收款银行',id: 'account_name'},
        {label: '开户地',id: 'area_info'},
        {label: '分支行',id: 'fenzhihang'},
      ],
      bankToData:{},
      bankNames: [
        {src:'jianshe',label:'建设银行',code:'CCB_B2B',keyword:['建设银行','建行']},
        {src:'gongshang',label:'工商银行',code:'ICBC_B2B',keyword:['工商银行','工行']},
        {src:'zhongguo',label:'中国银行',code:'BOC_B2B',keyword:['中国银行','中行']},
        {src:'nongye',label:'农业银行',code:'ABC_B2B',keyword:['农业银行','农行']},
        {src:'zhaoshang',label:'招商银行',code:'CMBCHINA_B2B',keyword:['招商银行','招行']},
        {src:'guangda',label:'光大银行',code:'CEB_B2B',keyword:['光大银行']},
        {src:'pufa',label:'浦发银行',code:'SPDB_B2B',keyword:['浦发银行']},
        {src:'mingsheng',label:'民生银行',code:'CMBC_B2B',keyword:['民生银行']},
        {src:'zhongxin',label:'中信银行',code:'ECITIC_B2B',keyword:['中信银行']},
        {src:'pingan',label:'平安银行',code:'SZPA_B2B',keyword:['平安银行']},
        {src:'jiaotong',label:'交通银行',code:'BOCO_B2B',keyword:['交通银行','交行']},
        {src:'huaxia',label:'华夏银行',code:'HXB_B2B',keyword:['华夏银行']},
        {src:'xingye',label:'兴业银行',code:'CIB_B2B',keyword:['兴业银行']},
        // {src:'ningbo',label:'宁波银行',code:''},
        {src:'youzheng',label:'中国邮政',code:'PSBC_B2B',keyword:['中国邮政','邮政储蓄','邮政银行']},
        {src:'beijing',label:'北京银行',code:'BCCB_B2B',keyword:['北京银行']},
        {src:'zheshang',label:'浙商银行',code:'CZ_B2B',keyword:['浙商银行']},
        {src:'shanghai',label:'上海银行',code:'SHB_B2B',keyword:['上海银行']},
        {src:'xiamen',label:'厦门银行',code:'XMCCB_B2B',keyword:['厦门银行']},
        {src:'weishang',label:'徽商银行',code:'HSB_B2B',keyword:['徽商银行']},
      ],
      showYeePay:false,
      code2PayVisible:false,
      code2Data:{
        qrString: "",
        //二维码字符串
        qrCodePeriod: 0,
        payAmount: 0, //充值金额
      },
      payWithoutPassword: false,
      //是否免密支付
      showPayAssets: false,
      //是否展示交易可用
      payCancelId: '',
      maskLoading: false,
      payMethod: 'single',
      //批量支付,单一支付
      tradeCardList: ['hxb', 'advance_payment'],
      //使用交易卡的支付方式
      zyMethodArr: ['ICP', 'credit', 'mix'],
      //自营记账支付方式
      order_type: '',
      account_id: '',
      shop_card_id: '',
      //佣金卡ID
      isHxCard: false,
      //是否绑定华夏卡
      haxiaCradMessage: {
        icd_assets: 0
      },
      //华夏银行卡余额等信息
      shopCardMessage: {},
      //用金卡信息
      payMessage: {},
      resultVisible: false,
      Alipay,
      Logo,
      WechartPay,
      dataLoading: false,
      orderOption: {
        field: paymentField,
        showAll: true,
        showBanner: false,
        showLogo: false,
        maxLabelWidth: 48
      },
      orderInfo: {
        list: []
      },
      //支付信息对象
      methodLoading: false,
      activePayMethod: 'wallet',
      activeWalletType: 'ICP',
      //钱包的支付类型，目前只有一种
      payType: [
        // {
        //   name: '记账支付',
        //   img: XinPay,
        //   active: true,
        //   id: 'XinPay',
        //   payType: 'wallet',
        // },
        // {
        //   name: '华夏银行',
        //   img: HuaXia,
        //   active: false,
        //   id: 'hxb',
        //   payType: 'hxb',
        // },
        // {
        //   name: '委托垫付',
        //   img: AdvancePayment,
        //   active: false,
        //   id: 'AdvancePayment',
        //   payType: 'advance_payment',
        // },
        // {
        //   name: '微信',
        //   img: WechartPay,
        //   active: false,
        //   id: 'wechat',
        //   payType: 'online',
        // },
        // {
        //   name: '支付宝',
        //   img: Alipay,
        //   active: false,
        //   id: 'alipay',
        //   payType: 'online',
        // },
        // {
        //   name: '银行转账',
        //   img: BankTransfer,
        //   active: false,
        // },
      ],
      walletList: [{
        id: 'ICP',
        name: translateI18n('portal.ji-zhang-zhi-fu'),
        cardInfo: {},
        card_type: 'trader'
      }
      // { id: 'GTP', name: '担保支付', cardInfo: {} }, // 暂时隐藏
      // { id: 'credit', name: '信用支付', cardInfo: {} }
      ],
      activeOnlineType: 'wechat',
      offlinePayeeInfo,
      passwordForm: {
        password: ''
      },
      balanceForm: {
        asset_amount: ''
      },
      paymentRule,
      balanceRule: {
        asset_amount: [{
          required: true,
          trigger: 'change',
          validator: checkPrice
        }]
      },
      remarkForm: {
        remark: ''
      },
      forgetData: {
        verifyData: {
          visible: false,
          title: translateI18n('portal.yan-zheng-ma-jiao-yan'),
          forgetPasswordData: {
            tel: '',
            verify_code: ''
          }
        },
        setNewData: {
          visible: false,
          title: translateI18n('portal.she-zhi-xin-mi-ma'),
          firstTime: false
        },
        resultData: {
          visible: false,
          title: translateI18n('portal.ti-shi'),
          resultType: '',
          content: '',
          customClassName: 'mini-dialog'
        }
      },
      WechartData: {},
      wechartPayVisible: false,
      AlipayData: {},
      alipayPayVisible: false,
      bankImgs:{},
      curBank:'jianshe',
      bank_code:"CCB_B2B",
      orderType:'',
      diaTit:"",
      payAgain:false
    };
  },
  computed: {
    showPWD() {
      const arr = ['bankTo', 'wangyin', 'yeepay', 'online']
      return !arr.includes(this.activePayMethod) && !this.payWithoutPassword
    },
    ...mapState({
      socketMsg: state => state.socketMsg
    }),
    postOrderId() {
      //return ['order_01J14GSWSBC9MZD3MEH93TQZDY','order_01J14GF2T7H6S2JT03AGE8A536'];//模拟批量支付
      if (!Array.isArray(this.orderId)) {
        return [this.orderId];
      }
      return this.orderId;
    },
    credit_amount() {//需要支付的信用(需要支付的信用不能大于信用余额)
      if (//资产不符合规范的时候，支付信用展示0
          this.balanceForm.asset_amount === '' ||
          this.balanceForm.asset_amount < 0 ||
          (this.balanceForm.asset_amount && !regexMoneyNumber(this.balanceForm.asset_amount, 4))
      ) {
        return 0;
      }
      if (this.orderInfo.total - multiplication(this.balanceForm.asset_amount, 10000) > this.activeWallet.cardInfo.icw_assets) {
        //需要支付的费用-资产>信用余额
        return this.activeWallet.cardInfo.icw_assets;
      }
      if (this.orderInfo.total - multiplication(this.balanceForm.asset_amount, 10000) <= this.activeWallet.cardInfo.icw_assets) {
        return Math.max(this.orderInfo.total - multiplication(this.balanceForm.asset_amount, 10000), 0);
      }
    },
    // 当前选中的芯支付类型数据（目前只有一个，就是ICP）
    activeWallet() {
      //交易卡
      return this.walletList.find(item => item.id === this.activeWalletType);
    },
    // 多种情况决定支付是否可以点击
    isPaymentDisabled() {
      // loading中不能支付
      if (this.dataLoading || this.methodLoading || !this.isHxCard && this.activePayMethod === 'hxb') return true;
      return false;
    }
  },
  created() {
    if(process.client) {
      this.loadImages()
      if(this.payConfig.payment_term_title === 'TT') {
        this.diaTit = '收银台'
      } else if(this.payConfig.payment_term_title === 'COD' || this.payConfig.payment_term_title.includes('NET')){
        this.diaTit = '记账台'
      } else {
        this.diaTit = '支付收银台'
      }
    }
  },
  watch: {
    paymentVisible: {
      immediate: true,
      handler: function (val) {
        if (val) {
          if (this.accountType === 'S' || this.accountType === 'P') {
            let url = this.accountType === 'S' ? '/rest/store/biz/v3/sales-order/' : '/rest/store/biz/v3/purchase-order/';
            this.getAccountOrderInfo(url);
          } else {
            this.getOrderInfo();
          }
        }
      }
    },
    async socketMsg(val) {
      if (val.target === 'order_payment_result') {
        this.hideAdd();
        let content = val.content;
        if (!Array.isArray(content.data)) {
          //支付失败
          this.payMessage.is_success = content.is_success;
          this.payMethod = 'single';
          this.$message.error(content.info);
          this.payAgain = true
        } else {
          this.payAgain = false
          if (content.data.length > 1) {
            this.payMethod = 'serie';
            this.payMessage = content;
          } else {
            this.payMethod = 'single';
            this.payMessage = content.data[0];
            this.payMessage.note = content.note;
          }
        }
        this.resultVisible = true;
        this.$emit('payAgain',this.payAgain)
      }
    }
  },
  mounted() {
    if (process.client) {
      let profile = storage.get("profile");
      this.profiles = profile
      if (profile?.latest_account_id) {
        this.account_id = profile.latest_account_id;
      }
    }
  },
  methods: {
    async selectStep(v) {
      if(v === 2) {
        const res = await this.submitPayment()
        if(res) {
          this.step = v
        }
      } else {
        this.payCancel({id: this.payCancelId });
        this.step = v
      }

    },
    copy(content) {
      const input = document.createElement('input');
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('value', content);
      document.body.appendChild(input);
      input.select();
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        this.$message.success(this.$t('portal.yi-fu-zhi'));
      }
      document.body.removeChild(input);
    },
    chooseBank(v) {
      this.curBank = v.src
      this.bank_code = v.code
    },
    loadImages() {
      const context = require.context('~/common/assets/img/banks', false, /\.png$/);
      context.keys().forEach((key) => {
        const imageName = key.replace('./', '').replace(/\.png$/, '');
        this.bankImgs[imageName] = context(key);
      });
    },
    setAccountPaylist() {
      //业务域支付方式（支付一致性调整，目前只有外联单，平台单走原来的逻辑）
      this.payType = [{
        name: translateI18n('portal.ji-zhang-zhi-fu'),
        img: XinPay,
        active: true,
        id: 'XinPay',
        payType: 'wallet'
      }];
      this.activePayMethod = 'wallet';
    },
    setPaylist(type, list) {//设置支付方式
      /**
       *
       * trade :  0国内 1:跨境进口 2:跨境出口 3:海外
         type:  platform:平台单，self-operated内联单(自营)，offline外联，service：服务单
        规则：
          1.记账支付：内联单非跨境进口，或平台单且海外或平台单且跨境出口
          2.银行支付，内联单且跨境进口，或平台单且国内或平台单且跨境进口
          3、全部等于记账支付，才可以使用记账,否则只支付银行支付的部分
      */
      if(this.batchPay) {
        let credits = 0
        let banks = 0
        let bankArr = []
        list.map(v => {
          const flag = this.payTypeJudge(v)
          if( flag === 'credit') {
            credits++
          }
          if(flag === 'bank') {
            banks++
            bankArr.push(v)
          }
        })
        this.bankIdsArr = bankArr.map(v => v.id)
        this.bankArr = bankArr
        if(banks > 0 && credits >0) {
          this.$alert(`存在多种支付方式，系统优先选择银行支付，支付成功后请再次选择支付剩余订单。`, "提示", {
            confirmButtonText: "确认",
            type: "warning",
          });
        }
        if(credits ===  list.length) {
          //全部等于记账支付，才可以使用记账
          this.payType = [{
            name: '记账支付',
            img: XinPay,
            active: true,
            id: 'XinPay',
            payType: 'wallet',
          }]
          this.activePayMethod = 'wallet';
        } else {
          //其他都是银行支付
          if(this.bankIdsArr.length === 1) {
            this.payType=[
              {
                name: '华夏银行',
                img: HuaXia,
                active: true,
                id: 'hxb',
                payType: 'hxb',
              },
              {
                name: translateI18n('portal.ji-zhang-zhi-fu'),
                img: XinPay,
                active: false,
                id: 'XinPay',
                payType: 'wallet'
              },
              // {
              //   name: '委托垫付',
              //   img: AdvancePayment,
              //   active: false,
              //   id: 'AdvancePayment',
              //   payType: 'advance_payment',
              // },
              {
                name: '微信',
                img: WechartPay,
                active: false,
                id: 'wechat',
                payType: 'online',
              },
              {
                name: '支付宝',
                img: Alipay,
                active: false,
                id: 'alipay',
                payType: 'online',
              },
            ]
          } else {
            this.payType=[
              {
                name: '华夏银行',
                img: HuaXia,
                active: true,
                id: 'hxb',
                payType: 'hxb',
              },
              {
                name: translateI18n('portal.ji-zhang-zhi-fu'),
                img: XinPay,
                active: false,
                id: 'XinPay',
                payType: 'wallet'
              },
              // {
              //   name: '委托垫付',
              //   img: AdvancePayment,
              //   active: false,
              //   id: 'AdvancePayment',
              //   payType: 'advance_payment',
              // },
            ]
          }
          this.activePayMethod = 'hxb';
        }
        return
      }
      let {payment_type = 'ICP', type: payType, category, trade} = list[0]
      if(payType ==='platform' || payType === 'self-operated') {
        this.showYeePay = true
      }
      this.orderType = payType
      if (type === 'ret') {//退款单
        this.showYeePay = false
        if (payment_type === 'IOU') {//担保支付
          this.payType = [{
            name: translateI18n('portal.hua-xia-yin-hang'),
            img: HuaXia,
            active: true,
            id: 'hxb',
            payType: 'hxb'
          }];
          this.activePayMethod = 'hxb';
        }
        if (payment_type === 'hxb') {
          //银行转账（目前只有华夏银行）
          this.payType = [{
            name: translateI18n('portal.hua-xia-yin-hang'),
            img: HuaXia,
            active: true,
            id: 'hxb',
            payType: 'hxb'
          }];
          this.activePayMethod = 'hxb';
        }
        if (this.zyMethodArr.includes(payment_type)) {
          //自营记账
          this.payType = [{
            name: translateI18n('portal.ji-zhang-zhi-fu'),
            img: XinPay,
            active: true,
            id: 'XinPay',
            payType: 'wallet'
          }];
          this.activePayMethod = 'wallet';
        }
      }
      if(this.profiles.shop_type === 'single') {
        this.showYeePay = true
        this.activePayMethod = 'wangyin';
        this.activeOnlineType = 'wangyin';
        this.payType = [
          {
            name: '网银转账',
            active: true,
            id: 'wangyin',
            payType: 'wangyin'
          },
          {
            name: '对公转账',
            active: false,
            id: 'bankTo',
            payType: 'bankTo'
          },
        ]
        this.payConfigSet()
        return
      }
      if (type === 'order') {
        //支付单
        if (payType === 'self-operated') {
          this.payType = [
            {
              name: '网银转账',
              active: true,
              id: 'wangyin',
              payType: 'wangyin'
            },
            {
              name: '对公转账',
              active: false,
              id: 'bankTo',
              payType: 'bankTo'
            },
            {
              name: translateI18n('portal.ji-zhang-zhi-fu'),
              // img: XinPay,
              active: false,
              id: 'XinPay',
              payType: 'wallet'
            },
          ];
          this.activePayMethod = 'wangyin';
        }
        else if (payType === 'platform' && trade === '1') {
          this.payType = [
            {
              name: '银行转账',
              active: true,
              id: 'hxb',
              payType: 'hxb'
            },
            // {
            //   name: translateI18n('portal.wei-tuo-dian-fu'),
            //   active: false,
            //   id: 'AdvancePayment',
            //   payType: 'advance_payment'
            // },
            {
              name: translateI18n('portal.ji-zhang-zhi-fu'),
              active: false,
              id: 'XinPay',
              payType: 'wallet'
            },
          ];
          this.activePayMethod = 'hxb';
        }
        else if (payType === 'platform' && trade === '0') {
          this.payType = [
            {
              name: '网银转账',
              active: true,
              id: 'wangyin',
              payType: 'wangyin'
            },
            {
              name: '对公转账',
              active: false,
              id: 'bankTo',
              payType: 'bankTo'
            },
            {
              name: '银行转账',
              active: false,
              id: 'hxb',
              payType: 'hxb'
            },
            // {
            //   name: translateI18n('portal.wei-tuo-dian-fu'),
            //   active: false,
            //   id: 'AdvancePayment',
            //   payType: 'advance_payment'
            // },
            {
              name: translateI18n('portal.ji-zhang-zhi-fu'),
              active: false,
              id: 'XinPay',
              payType: 'wallet'
            },
          // {
          //   name: translateI18n('portal.wei-xin'),
          //   img: WechartPay,
          //   active: false,
          //   id: 'wechat',
          //   payType: 'online'
          // },
          // {
          //   name: translateI18n('portal.zhi-fu-bao'),
          //   img: Alipay,
          //   active: false,
          //   id: 'alipay',
          //   payType: 'online'
          // }
          ];
          this.activePayMethod = 'wangyin';
        }
        else if (payType === 'platform' && (trade === '2' || trade === '3')) {
          this.payType = [
            {
              name: '网银转账',
              active: true,
              id: 'wangyin',
              payType: 'wangyin'
            },
            {
              name: '对公转账',
              active: false,
              id: 'bankTo',
              payType: 'bankTo'
            },
            {
              name: translateI18n('portal.ji-zhang-zhi-fu'),
              active: false,
              id: 'XinPay',
              payType: 'wallet'
            },
          ];
          this.activePayMethod = 'wangyin';
        }
        else if (payType === 'offline') {
          //订单域外联单
          this.payType = [{
            name: translateI18n('portal.ji-zhang-zhi-fu'),
            img: XinPay,
            active: true,
            id: 'XinPay',
            payType: 'wallet'
          }];
          this.activePayMethod = 'wallet';
        }
        else {
            // 其他单保持原有逻辑
          this.payType = [{
            name: translateI18n('portal.ji-zhang-zhi-fu'),
            img: XinPay,
            active: true,
            id: 'XinPay',
            payType: 'wallet'
          }, {
            name: translateI18n('portal.hua-xia-yin-hang'),
            img: HuaXia,
            active: false,
            id: 'hxb',
            payType: 'hxb'
          }, {
            name: translateI18n('portal.wei-tuo-dian-fu'),
            img: AdvancePayment,
            active: false,
            id: 'AdvancePayment',
            payType: 'advance_payment'
          }, {
            name: translateI18n('portal.wei-xin'),
            img: WechartPay,
            active: false,
            id: 'wechat',
            payType: 'online'
          }, {
            name: translateI18n('portal.zhi-fu-bao'),
            img: Alipay,
            active: false,
            id: 'alipay',
            payType: 'online'
          }];
          this.activePayMethod = 'wallet';
        }
        this.payConfigSet()
      }
    },
    payConfigSet() {
      if(this.orderType === 'offline') {
        return
      }
      //只要父级传入了数据，就按照约定支付方式
      const {payment_methods_default,bank_name,payment_term_title} = this.payConfig
      const names = this.payType.map(v => v.name)
      if(this.showYeePay) {
        names.push('扫码支付')
      }
      if(payment_term_title && payment_term_title.includes('NET')) return
      if(payment_methods_default === '网银') {
        this.activePayMethod = 'wangyin';
        this.activeOnlineType = 'wangyin'
        if(bank_name) {
          for(let k = 0; k <  this.bankNames.length; k++) {
            const {keyword,src,code} =  this.bankNames[k]
            let hasBank = false
            keyword.forEach(val => {
              if(bank_name.includes(val)) {
                hasBank = true
              }
            })
            if(hasBank) {
              this.curBank = src
              this.bank_code = code
              break
            }
          }
        }
        this.changePayType('wangyin')
      } else if(payment_methods_default === '转账') {
        this.activePayMethod = 'bankTo';
        this.activeOnlineType = 'bankTo'
        this.changePayType('bankTo')
      } else if(payment_methods_default === '二维码') {
        this.activePayMethod = 'yeepay';
        this.activeOnlineType = 'yeepay';
        this.changePayType('yeepay')
      }
      
      
    },
    payTypeJudge(res) {
      const {payment_type = 'ICP', type: payType, trade} = res;
      let f = ''
      if((payType === 'platform' &&(trade === '2' || trade === '3')) || (payType === 'self-operated' && trade !== '1')) {
        // 记账支付
        f = 'credit'
      }
      else if((payType === 'platform' &&(trade === '0' || trade === '1')) || (payType === 'self-operated' && trade === '1')) {
        // 银行支付
        f = 'bank'
      }
      return f
    },
    async getHxCardOpen() {//获取华夏卡是否开通
      const { code, data, msg } = await this.$axios.$post('/rest/store/hub/v3/payment/hxb/bindCardInfo', { card_id: this.shop_card_id }, { headers: { showNotify: false } }).catch(() => ({ code: 40000, data: {}, msg: translateI18n('portal.fu-wu-chu-cuo') }));
      if (code !== 200) {
        this.isHxCard = false;
        return;
      }
      ;
      this.isHxCard = true;
    },
    async getHxCardDetail() {
      //获取华夏卡余额等信息
      const {
        code,
        data,
        msg
      } = await this.$axios.$post('/rest/store/hub/v3/payment/hxb/balanceQuery', {
        card_id: this.shop_card_id
      }, {
        headers: {
          showNotify: false
        }
      }).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) {
        // this.isHxCard = false;
        return;
      }
      ;
      this.isHxCard = true;
      this.haxiaCradMessage.icd_assets = data.available_assets;
    },
    async changePayType(key) {
      if(this.changeTypeBtnState === 'notClick') {
        return
      }
      this.changeTypeBtnState = 'notClick'
      if(key === this.beforeKey) {
        return 
      } else {
        this.beforeKey = key
      }
      if(key === 'yeepay') {
        this.activePayMethod = 'yeepay';
        this.activeOnlineType = 'yeepay';
      } else {
        this.payType.forEach(v => {
          if(v.id === key) {
            this.activePayMethod = v.payType;
            this.activeOnlineType = v.id;
          }
        })
      }
      if(this.payCancelId) {
        await this.payCancel({
          id: this.payCancelId
        })
      }
      if(key === 'yeepay') {
        await this.submitPayment()
      } else {
        if(this.step === 2  && ['wangyin', 'bankTo'].includes(this.activePayMethod)) {
          this.step = 1
        }
      }
      this.changeTypeBtnState = 'doClick'
    },
    chainStr(arr = []) {
      let strs =  arr.reduce((current, item, index) => {
        let actual_total = item.total_cny;
        if (item.approved_status === 'S') {
          actual_total = item.difference_total_cny;
        }
        if (this.accountType === 'S' || this.accountType === 'P') {
          //业务单
          actual_total = item.total;
        }
        this.personStr = ''
        if(item.type!=='offline') {
          this.personStr = `，收款方：${item.right_info.name}，付款方：${item.left_info.name}`
        }
        return current + this.$t('portal.ding-dan-hao-xiang-shu-jine01', [item.order_number, item.line_item_count, this.formatMoney(actual_total), index % 2 == 1 ? '；<br />' : '；']) + this.personStr
      }, '');
      return strs
    },
    hideAdd(type) {
      if(this.$refs.code2Pay) {
        this.$refs.code2Pay.clearIntervalTimes()
      }
      this.payFlag1 = false
      this.$refs['balanceForm']?.[0]?.resetFields();
      this.$refs['passwordFormDom']?.resetFields();
      this.orderInfo = {
        list: []
      };
      this.bankToData = {}
      this.bankToDone = '-1'
      this.step = 1
      let m = this.$store.state.pay.payRefresh;
      this.$store.commit('pay/set_payRefresh', ++m);
      if(type ==='zhuan-done') {
        this.$emit('hide');
        return
      }
      if(this.payCancelId && ['wangyin','bankTo', 'yeepay'].includes(this.activePayMethod)) {
        this.payCancel({
          id: this.payCancelId
        })
      }
      this.$emit('hide');
      
    },
    async getAccountOrderInfo(url) {
      //获取业务域订单详情
      this.dataLoading = true;
      const {
        code,
        msg,
        data
      } = await this.$axios.$get(`${url}${this.orderId}`).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      this.dataLoading = false;
      if (code !== 200) return;
      this.orderInfo.list = [{
        order_number: data.order_number,
        line_item_count: data.order_count.line_count,
        total: data.order_count.grand_total_cny,
        type:'offline'
      }]; //订单笔数：默认为1
      this.orderInfo.total = data.order_count.grand_total_cny;
      this.setAccountPaylist();
      const {
        shop_id,
        shop_member_id,
        left: {
          id: left_id
        },
        right: {
          id: right_id
        }
      } = data || {};
      this.getPasswordCon({
        shop_id: shop_id,
        shop_member_id: shop_member_id
      });
      if (this.accountType === 'S') {
        this.getCardInfo({
          card_type: 'contacts',
          account_gross_id: right_id
        }, 'contacts'); //获取往来卡信息
      } else {
        this.getCardInfo({
          card_type: this.activeWallet.card_type,
          trader_id: shop_member_id,
          shop_id
        }); //获取交易卡信息
      }
    },
    // 获取订单信息
    async getOrderInfo() {
      //优化后，替换成cg提供的新接口
      this.dataLoading = true;
      const {
        code,
        msg,
        data
      } = await this.$axios.$post(this.orderDetailUrl, {
        ids: this.postOrderId
      }).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      this.dataLoading = false;
      if (code !== 200) return;
      this.merchantNo = data.list[0].metadata?.merchant_no
      this.merchantPaymentUnactivated()
      data.list?.map(item => Object.assign(item, item?.metadata));
      Object.assign(this.orderInfo, data);
      this.orderInfo.total = data.total_cny; //处理非人民币问题
      this.order_type = this.postOrderId[0]?.split('_')[0];
      this.setPaylist(this.order_type, data.list);
      // 然后获取芯支付-芯币支付的支付信息
      const {
        shop_id,
        shop_member_id,
        left_info: {
          id
        },
        trade,
        payment_type,
        bill_to = '',
        account_id,
        type,
        match_type,
        is_sell_up
      } = this.orderInfo.list[0] || {}; //shop_id:交易员商户ID;shop_member_id：交易员id;trade==='1':跨境进口
      this.showPayAssets = !is_sell_up;
      // this.getPayShopMess(shop_id)
      this.getPasswordCon({
        shop_id: shop_id,
        shop_member_id: shop_member_id
      });
      if (!this.zyMethodArr.includes(payment_type) && trade === '1' && this.order_type === 'ret') {
        //
        const data = await this.getShopMess(bill_to);
        this.getCardInfo({
          card_type: this.activeWallet.card_type,
          trader_id: data?.shop_member_id,
          shop_id: data?.shop_id
        }); //获取交易卡信息
        this.getCardInfo({
          card_type: 'commission',
          account_commission_id: bill_to
        }, 'shop'); //获取佣金卡信息
      } else {
        if (type === 'offline' && match_type === 'S') {
          //外联销售单：付款卡为：外联销售单的买方，即毛利账户的往来卡
          this.getCardInfo({
            card_type: 'contacts',
            account_gross_id: account_id
          }, 'contacts'); //查找往来账簿信息
        } else {
          //外联采购单：付款卡为：外联采购单的买方，即买方交易员的交易卡（其他单，平台单等，也是查的交易卡）
          this.getCardInfo({
            card_type: this.activeWallet.card_type,
            trader_id: shop_member_id,
            shop_id
          }); //获取交易卡信息
        }
        this.getCardInfo({
          card_type: 'commission',
          account_commission_id: id
        }, 'shop'); //获取佣金卡信息
      }
    },
    async getShopMess(id) {
      const {
        code,
        msg,
        data = {}
      } = await this.$axios.$post('/rest/store/account/v3/account/shop', {
        id: id
      }).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      if (code !== 200) return;
      return data;
    },
    async getPasswordCon(param) {
      const {
        code,
        msg,
        data = {}
      } = await this.$axios.$post('/rest/store/hub/v3/payment/checkPasswordFree', param, {
        headers: {
          showNotify: false
        }
      }).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      if (code !== 200) return;
      this.payWithoutPassword = data.password_free;
    },
    // async getPayShopMess(id){//获取付款方所在商户的商户类型
    //   const { code, msg, data } = await this.$axios.$get(`/rest/store/contact/v3/contact_shop/public_info/${id}`).catch(() => ({ code: 40000, msg: '服务出错', data: {} }));
    //   if (code !==200) return;
    //   this.showPayAssets = (data.shop_type==='partner' || data.shop_type==='shareholder');
    // },
    // 获取芯支付-芯币支付的支付信息
    async getCardInfo(params, type) {
      this.methodLoading = true;
      const {
        code,
        msg,
        data
      } = await this.$axios.$post(apiGetPaymentCardInfo, params).catch(() => ({
        code: 40000,
        msg: translateI18n('portal.fu-wu-chu-cuo'),
        data: {}
      }));
      this.methodLoading = false;
      if (code !== 200) return;
      if (type === 'shop') {
        this.shop_card_id = data.card_id;
        this.shopCardMessage = data;
        this.getHxCardOpen();
        this.getHxCardDetail();
      } else {
        this.activeWallet.cardInfo = data;
        this.setBalance(data);
      }
    },
    setBalance(data) {
      //设置资产默认值
      if (this.orderInfo.total > data.icd_assets) {
        //单总额大于芯币可用余额
        this.balanceForm.asset_amount = data.icd_assets / 10000;
      }
      if (this.orderInfo.total < data.icd_assets) {
        //单总额小于芯币可用余额
        this.balanceForm.asset_amount = this.orderInfo.total / 10000;
      }
      if (this.orderInfo.total === data.icd_assets) {//单总额小于芯币可用余额
        this.balanceForm.asset_amount = data.icd_assets / 10000;
      }
      if (data.icd_assets < 0) {//芯币可用余额为负数
        this.balanceForm.asset_amount = 0;
      }
    },
    // 银行卡隐藏，只显示后四位
    hideCardNumber(value = '', none = '--') {
      if (!value) return none;
      const stringValue = value.toString();
      if (stringValue.length <= 4) return stringValue;
      return `****${stringValue.substring(stringValue.length - 4)}`;
    },
    // 金额格式处理
    formatMoney(value = 0, noSymbol = false) {
      if (value === 0) {
        return '0';
      }
      return icFilters.formatMoney(value, null, 4, null, noSymbol, null, '2');
    },
    // 点击忘记密码，弹出验证码框
    async showVerifyDialog() {
      const {
        code,
        data,
        msg
      } = await this.$axios.$get(apiGetCardDetail).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) return;
      // 手机号取值需要处理一下，截掉前面的区号和空格
      const {
        registeredCellphone = ''
      } = data || {};
      const arrPhone = registeredCellphone.toString().split(' ');
      const lastPhone = typeof arrPhone[1] === 'undefined' ? arrPhone[0] : arrPhone[1];
      if (!lastPhone) {
        return this.$message.warning({
          message: translateI18n('portal.zhao-hui-mi-ma')
        });
      }
      Object.assign(this.forgetData.verifyData, {
        visible: true,
        forgetPasswordData: {
          tel: lastPhone,
          verify_code: ''
        }
      });
    },
    // 隐藏验证码校验弹窗
    hideVerify() {
      Object.assign(this.forgetData.verifyData, {
        visible: false
      });
    },
    // 显示设置密码弹窗
    verifyPhoneOk() {
      this.hideVerify();
      Object.assign(this.forgetData.setNewData, {
        visible: true
      });
    },
    // 隐藏设置密码弹窗
    hideSet() {
      Object.assign(this.forgetData.setNewData, {
        visible: false
      });
    },
    // 设置支付密码
    async setNewPsd({
      new_password
    }, okCallback) {
      // let id;
      // if (this.tradeCardList.includes(this.activePayMethod)) {
      //   id = this.shopCardMessage.card_id;
      // } else {
      //   id = this.activeWallet.cardInfo.card_id;
      // }
      let id = this.activeWallet.cardInfo.card_id;
      const {
        code,
        data,
        msg
      } = await this.$axios.$post(apiSetCardPassword, {
        id: id,
        new_password
      }).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) return;
      okCallback();
      Object.assign(this.forgetData.resultData, {
        visible: true,
        resultType: 'success',
        content: translateI18n('portal.mi-ma-she-zhi-cheng-gong')
      });
    },
    hideOrderPaymentResult(res) {
      this.resultVisible = false;
      this.$emit('update');
      if(res?.isSuccess && this.payConfig?.payment_methods_default && this.orderType !=='offline' ) {
        window.location.href = window.location.origin + `/store/order/${ this.payConfig?.orderType === 'S' ? 'sale_bill' : 'purchase_bill'}`
      }
    },
    // 隐藏修改结果提示弹窗
    hideResult() {
      Object.assign(this.forgetData.resultData, {
        visible: false
      });
    },
    // 点击“立即支付”按钮，不同的支付方式走不同的逻辑
    async submitPayment() {
      if(process.env.PROJECT_NAME === 'seo') {
        trackEventApi({
          $route: this.$route,
          value: [
            {page_type:'detail',url: this.$route.fullPath, object_code: this.payNumber ? this.payNumber : this.$route.params.id,component_name:'立即支付'},
          ]
        })
      }

      switch (this.activePayMethod) {
        case 'wallet':
          this.payForWallet();
          break;
        case 'online':
          return await this.payForOnline();
          break;
        case 'offline':
          this.payForOffline();
          break;
        case 'hxb':
          this.payForHxb();
          break;
        case 'advance_payment':
          this.payForAdvancePayment();
          break;
        case 'yeepay':
          if(!this.merchantPaymentUnactivated()) {
            return
          }
          return await this.payForOnline()
          break;
        case 'wangyin':
          if(!this.merchantPaymentUnactivated()) {
            return
          }
          return  await this.payForOnline()
          break;
        case 'bankTo':
          if(!this.merchantPaymentUnactivated()) {
            return
          }
          return await this.payForOnline()
        break;
      }
    },
    async payForHxb() {
      //华夏银行支付
      const validatePassword = await this.$refs.passwordFormDom.validate().catch(() => false);
      if (!this.payWithoutPassword && !validatePassword) {
        return this.$message.warning(translateI18n('portal.zheng-que-mi-ma'));
      }
      if (this.haxiaCradMessage.icd_assets < this.orderInfo.total) {
        return this.$message.warning(translateI18n('portal.gong-si-hua-xia-zhang-hu-ke-yong-yuebu-zu'));
      }
      if (this.showPayAssets && this.activeWallet.cardInfo.icd_assets + this.activeWallet.cardInfo.icw_assets < this.orderInfo.total) {
        return this.$message.warning(translateI18n('portal.nin-de-ke-yong-yuebu-zu', [this.activeWallet.cardInfo.card_type]));
      }
      const params = {
        order_ids: this.batchPay ? this.bankIdsArr : this.postOrderId,
        card_id: this.shop_card_id,
        password: this.passwordForm.password,
        payment_type: 'hxb',
        asset_amount: this.orderInfo.total,
        description: this.remarkForm.remark,
        out_trade_no: ''
      };
      this.requestPayment(params);
    },
    async payForAdvancePayment() {
      //委托垫付支付
      const validatePassword = await this.$refs.passwordFormDom.validate().catch(() => false);
      if (!this.payWithoutPassword && !validatePassword) {
        return this.$message.warning(translateI18n('portal.zheng-que-mi-ma'));
      }
      if (this.activeWallet.cardInfo.iou_assets < this.orderInfo.total) {
        return this.$message.warning(translateI18n('portal.wei-tuo-dian-fu-ke-yong-yuebu-zu'));
      }
      if (this.showPayAssets && this.activeWallet.cardInfo.icd_assets + this.activeWallet.cardInfo.icw_assets < this.orderInfo.total) {
        return this.$message.warning(translateI18n('portal.nin-de-ke-yong-yuebu-zu', [this.activeWallet.cardInfo.card_type]));
      }
      const params = {
        order_ids: this.batchPay ? this.bankIdsArr : this.postOrderId,
        card_id: this.activeWallet.cardInfo.card_id,
        password: this.passwordForm.password,
        payment_type: 'IOU',
        asset_amount: this.orderInfo.total,
        description: this.remarkForm.remark,
        out_trade_no: ''
      };
      this.requestPayment(params);
    },
    // 选择“芯支付”
    async payForWallet() {
      const {
        total = 0
      } = this.orderInfo;
      const {
        icd_assets = 0,
        card_id,
        icw_assets = 0,
        card_type = ''
      } = this.activeWallet.cardInfo || {};
      // 芯支付下需要查到支付卡信息才能支付
      if (!card_id || card_id === '0') {
        return this.$message.warning(translateI18n('portal.0-wei-kai-tong-qing-lian-xi-nin-de-hu-zhu-kai-tong', [card_type]));
      }
      if (this.activeWallet.cardInfo.icd_assets < 0 && this.balanceForm.asset_amount > 0) {
        return this.$message.warning(translateI18n('portal.mei-you-ke-yong-yu-e'));
      }
      // 资产大于资产余额
      if (this.activeWallet.cardInfo.icd_assets >= 0 && multiplication(this.balanceForm.asset_amount, 10000) > icd_assets) {
        return this.$message.warning(translateI18n('portal.shu-ru-zi-chan-bu-neng-da-yu-zi-chan-yu-e'));
      }
      // 信用大于信用余额
      if (this.credit_amount > icw_assets) {
        return this.$message.warning(translateI18n('portal.shi-yong-xin-yong-bu-neng-da-yu-xin-yong-yu-e'));
      }
      //资产加信用不等于单据金额
      if (multiplication(this.balanceForm.asset_amount, 10000) + this.credit_amount !== total) {
        return this.$message.warning(translateI18n('portal.ke-yong-yuebu-zu'));
      }
      const validatePassword = await this.$refs.passwordFormDom.validate().catch(() => false);
      // const validateBalance = await this.$refs.balanceForm[0].validate().catch(() => false);
      // if (!validateBalance) {
      //   return this.$message.warning('请输入正确的资产');
      // }
      if (!this.payWithoutPassword&&!validatePassword) {
        return this.$message.warning(translateI18n('portal.zheng-que-mi-ma'));
      }
      // 通过表单校验后，处理请求参数，调用支付接口
      const params = {
        order_ids: this.postOrderId,
        card_id,
        password: this.passwordForm.password,
        payment_type: this.activeWalletType,
        asset_amount: multiplication(this.balanceForm.asset_amount, 10000),
        description: this.remarkForm.remark,
        credit_amount: this.credit_amount,
        out_trade_no: ''
      };
      this.requestPayment(params);
    },
    async getUniqueId(params) {
      const {
        code,
        data,
        msg
      } = await this.$axios.$post('/rest/store/order/v3/orders/payment/awaiting', params).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      if (code !== 200) {
        return {};
      }
      return data;
    },
    merchantPaymentUnactivated() {
      if(!this.merchantNo && ['yeepay','wangyin','bankTo'].includes(this.activePayMethod)) {
        this.$message.error('卖家商户未开通收款功能')
        return false
      }
      return true
    },
    // 选择第三方“微信/支付宝”支付
    async payForOnline({whichPay=''}={}) {
      const activePayMethod = whichPay ? whichPay : this.activePayMethod
      if (!this.activeWallet.cardInfo.card_id || this.activeWallet.cardInfo.card_id === '0') {
        return this.$message.warning(translateI18n('portal.0-wei-kai-tong-qing-lian-xi-nin-de-hu-zhu-kai-tong', [this.activeWallet.cardInfo.card_type]));
      }
      let uniData = await this.getUniqueId({
        ids: this.postOrderId
      });
      if (!uniData.unique_id) {
        return;
      }
      // 取到后组装参数
      const orderInfo = this.orderInfo;
      const activeOnlineType = this.activeOnlineType;
      const arr1 = ['bankTo','wangyin','yeepay']
      const yeepayCurrencyArr = ['yeepay','bankTo','wangyin']
      const rechargeParams = {
        amount: orderInfo.total / 10000,
        card_id: arr1.includes(activePayMethod) ? this.shop_card_id : this.activeWallet.cardInfo.card_id,
        currency_id: yeepayCurrencyArr.includes(activePayMethod) ? '1064324082092670979' : this.activeWallet.cardInfo.currency_id,
        description: this.remarkForm.remark,
        recharge_method: activeOnlineType,
        order_code: this.batchPay ? this.bankArr[0].order_no : this.postOrderId[0].order_no,
        order_id: this.batchPay ? this.bankArr[0].id : this.postOrderId[0].id,
        payment_unique_id: uniData.unique_id
      };
      if(activePayMethod === 'wangyin') {
        rechargeParams.recharge_method = 'yeepayCashier'
        rechargeParams.bank_code = this.bank_code
        rechargeParams.merchant_no = this.merchantNo
      } else if(activePayMethod === 'bankTo') {
        rechargeParams.recharge_method = 'yeepayBankTransfer'
        rechargeParams.merchant_no = this.merchantNo
      } else if(activePayMethod === 'yeepay') {
        rechargeParams.merchant_no = this.merchantNo
      }
      // 开始请求充值接口（先充值再支付）
      this.dataLoading = true;
      const {
        code,
        data,
        msg
      } = await this.$axios.$post(apiRechargeMoney, rechargeParams)
      this.dataLoading = false;
      if(code !== 200) {
        return false
      }
      this.payCancelId = data.id;
      if(activePayMethod === 'wangyin') {
        // this.payMsg = '支付中'
        // this.dataLoading = true;
        this.checkPay(data.id, this.postOrderId[0])
        window.open(data.pay_url)
        return true
      } else if(activePayMethod === 'bankTo') {
        this.bankToData = {...data.bank_transfer_info,account_name: '支付机构备付金集中存管账户', fenzhihang: '易宝支付-备付金账户'}
        // this.payFlag1 = true
        return true
      }
      // 拿到数据后唤起扫码充值的公共组件弹窗
      const payData = {
        qrString: data.pay_url,
        qrCodePeriod: data.time_expire,
        payAmount: Number(data.amount),
        id: data.id,
        order_id: this.batchPay ? this.bankArr[0] :this.postOrderId[0]
      };
      switch (activeOnlineType) {
        case 'wechat':
          this.WechartData = payData;
          this.wechartPayVisible = true;
          break;
        case 'alipay':
          this.AlipayData = payData;
          this.alipayPayVisible = true;
          break;
        case 'yeepay':
          this.code2Data = payData;
          this.code2PayVisible = true;
          break;
      }
      return true
    },
    payFlagCancel() {
      this.payCancel({
        id: this.payCancelId
      })
      this.cancelStatus = true
      this.payFlag = false
      this.payFlag1 = false
    },
    async payCancel(params) {
      if(!params?.id) return
      //第三方支付取消
      const {code,data,msg} = await this.$axios.$post('/rest/store/hub/v3/payment/payCancel', params)
      if(code !== 200) {
        this.$message.error(translateI18n('portal.fu-wu-chu-cuo'))
      } else {
        this.payCancelId = ''
        if(this.$refs.code2Pay) {
          this.$refs.code2Pay.clearIntervalTimes()
        }
        clearTimeout(this.wangyinTimer)
      }
    },
    // 接收充值结果，关闭第三方支付弹窗
    hideVisible(payType) {
      switch (payType) {
        case 'wechat':
          this.wechartPayVisible = false;
          this.WechartData = {};
          break;
        case 'alipay':
          this.alipayPayVisible = false;
          this.AlipayData = {};
          break;
        case 'yeepay':
          this.code2PayVisible = false;
          this.code2Data = {};
          break;
      }
    },
    // 选择“线下转账”
    payForOffline() {
      this.$message.warning(translateI18n('portal.zan-bu-zhi-chi-xian-xia'));
    },
    // 将最终支付函数抽离出来
    async requestPayment(params) {
      let match_type = this.orderInfo.list[0].match_type;
      let type = this.orderInfo.list[0].type;
      let order_type = this.postOrderId[0]?.split('_')[0];
      let loading = this.$loading({
        lock: true,
        text: translateI18n('portal.zhi-fu-zhong-qing-nai-xin-deng-dai'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.5)',
        customClass: 'payNewDia'
      });
      this.dataLoading = true;
      let url;
      if (this.accountType === 'S') {
        url = '/rest/store/biz/v3/sales-order/pay';
      } else if (this.accountType === 'P') {
        url = '/rest/store/biz/v3/purchase-order/pay';
      } else {
        url = this.payUrl;
      }
      const {
        code,
        data,
        msg
      } = await this.$axios.$post(url, params).catch(() => ({
        code: 40000,
        data: {},
        msg: translateI18n('portal.fu-wu-chu-cuo')
      }));
      loading.close();
      this.dataLoading = false;
      // 关闭当前弹窗
      this.hideAdd();
      if (this.accountType === 'S' || this.accountType === 'P') {
        return;
      }
      if (!Array.isArray(data.data)) {
        //支付失败
        this.$set(this.payMessage, 'is_success', data.is_success);
        //this.payMessage.is_success = data.is_success;
        this.payMethod = 'single';
        this.$message.error(data.info);
      } else {
        if (data.data.length > 1) {
          this.payMethod = 'serie';
          this.payMessage = data;
        } else {
          this.payMethod = 'single';
          this.payMessage = data.data[0];
          this.payMessage.note = data.note;
        }
        this.payMessage.match_type = match_type;
        this.payMessage.type = type;
        this.payMessage.order_type = order_type;
      }
      this.resultVisible = true;
    },
    checkPay(id,order_id) {
      if(this.cancelStatus) {
        this.cancelStatus = false
        return
      }
      this.$axios.$post(`rest/store/hub/v3/payment/payResult`, {
        id,
        pay_method: 'yeepayCashier',
        order_id
      }, {
        headers: {
          showNotify: false
        }
      }).then(({
        code,
        data,
        msg
      }) => {
        if (code !== 200) {
          this.payResFail(); //支付失败
          return;
        }
        // 100：未支付、200：支付成功、400：支付失败
        if (data.status === '200') {
           //支付成功
           clearTimeout(this.wangyinTimer)
           this.payFlag = false
           this.resultVisible = true;
        } else {
          clearTimeout(this.wangyinTimer)
          this.payResFail(); //支付失败
        }
      });
    },
    payResFail() {
      this.resultVisible = true;
      this.payFlag = false
    }
  }
};
</script>

<style lang="less" >
.payNewDia {
  .el-icon-loading {
    font-size: 30px;
    color: #ffffff;
  }
  .el-loading-text{
    color: #ffffff;
  }
}
.order-payment {
  top: 10%;
  left: 50%;
  transform: translate(-50%, 0);
  .el-dialog__body {
    padding: 0;
    overflow-y: auto;
    max-height: 660px;
  }
  #tab-wallet,
  #tab-online,
  #tab-offline {
    width: 120px;
    text-align: center;
  }
  #pane-online .el-radio-group {
    display: flex;
    align-items: center;
  }
  .pay_message {
    height: 235px;
    overflow: hidden;
    position: relative;
    &.wallet{
      display:flex;
      align-items:center;
      .el-radio-group{
        width: 100%;
      }
      .el-radio{
        padding:0;
        margin: 0
      }
    }
    .el-radio__input {
      display: none; //目前只有一个选项，所以不展示选择圈
    }
    .el-radio__label {
      padding-left: 0;
      display: flex;
      flex: 1;
      align-items: center;
      justify-content: space-between;
    }
    .card {
      display: flex;
      width: 320px;
      color: @fc6;
      margin-right: 10px;
      flex-direction: column;
      .card_box {
        color: #ffffff;
        width: 180px;
        height: 90px;
        background-image: url(~/common/assets/img/bg_card_others.png);
        background-repeat: no-repeat;
        padding: 10px 14px;
        line-height: initial;
        font-weight: 500;
      }
      .card_name {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 2px;
      }
      .logo {
        width: 14px;
        margin-right: 5px;
      }
    }
    .card_not_open.card {
      flex: initial;
      margin-right: 30px;
    }
    .balance {
      display: flex;
      flex: 3;
      align-items: center;
      .lay-balance {
        margin-right: 10px;
        flex: 1;
      }
    }
    .credit {
      display: flex;
      // flex: 1;
      flex-basis: 330px;
      align-items: center;
      color: @fc6;
    }
  }
  .pay_message.hxb,
  .pay_message.advance_payment {
    display: flex;
    align-items: center;
    cursor: default;
    flex-wrap: wrap;
    .hxb_card.card_box {
      margin: 20px 0;
      background-image: url(~/common/assets/img/bg_card_hxb.png);
    }
    .balance {
      display: flex;
      flex: 1;
      align-items: center;
      .lay-balance {
        margin-right: 10px;
        flex: 1;
      }
    }
    .prompt_text {
      flex-basis: 100%;
      margin-bottom: 10px;
    }
  }
  .pay_message.advance_payment {
    .hxb_card.card_box {
      background-image: url(~/common/assets/img/bg_card_others.png);
    }
  }
  .base-info .el-col .u-val.money {
    color: #ff4d4d;
  }
  overflow: auto;
  .el-loading-mask {
    border: none;
  }
  .base-info .el-col .u-label {
    text-decoration: none;
    padding-right: 0;
  }
  .lay-order {
    position: relative;
    .order_des {
      .order_show {
        max-height: 300px;
        overflow-y: auto;
      }
    }
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 4px !important;
      .el-icon-circle-check {
        color: #67c23a;
        font-size: 20px;
        margin-right: 6px;
      }
    }
    .total {
      position: absolute;
      top: 7px;
      right: 40px;
      color: #3f3f3f;
      .currency_sign,
      .number {
        color: #ea5728;
        font-size: 20px;
      }
      .number {
        font-weight: 700;
        margin-left: 6px;
      }
    }
  }
  .lay-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 46px;
    padding: 0 10px;
    border-bottom: 1px solid #efefef;
    .title {
      font-size: 16px;
    }
    .back {
      cursor: pointer;
    }
  }
  .lay-order,
  .lay-pay,
  .lay-remark,
  .lay-password {
    padding: 20px 40px;
    border-bottom: 1px solid #efefef;
    .title {
      margin-bottom: 10px;
      font-size: 15px;
      line-height: 28px;
      color: #3f3f3f;
    }
  }
  .lay-password {
    margin-left: -5px;
    border-bottom: none;
    .el-form-item__error {
      top: 10px;
      left: 280px;
    }
  }
  .lay-order {
    .title {
      margin-left: -27px;
    }
    .base-info .el-col .u-label {
      text-decoration: none;
    }
    .custom-style {
      margin-bottom: 5px;
    }
  }
  .lay-pay {
    border-bottom: none;
    .pay_message {
      border-bottom: 1px solid #efefef;
      .hxb_prompt {
        padding: 30px 0;
      }
    }
    .pay_type {
      display: flex;
      padding-bottom: 20px;
      border-bottom: 1px solid #efefef;
      font-size: 0;
      .pay_type_item {
        margin-right: 30px;
        cursor: pointer;
        padding: 4px 20px;
        border: 1px solid #dcdfe6;
        &.platform{
          margin-right: 30px;
          cursor: pointer;
          padding: 4px;
          border: 1px solid #dcdfe6;
          width:140px;
          color: #303133;
          height: 40px;
          text-align: center;
          font-size: 18px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
      .pay_type_item.active {
        position: relative;
        border: 1px solid #ea5728;
      }
      .pay_type_item.active::after {
        content: url(~/common/assets/img/select.png);
        position: absolute;
        top: 0;
        right: -1px;
      }
      .pay_type_item.platform.active::after {
        content: url(~/common/assets/img/select.png);
        position: absolute;
        top: -1px;
        right: -1px;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
    .el-form-item.form-item-balance {
      margin-right: 10px;
      .el-input {
        min-width: 110px;
      }
    }
    .el-tabs__header {
      margin-bottom: 10px;
    }
    .el-tabs__content {
      padding: 0 5px;
    }
    .el-radio-group {
      display: block;
    }
    .el-radio {
      display: flex;
      padding: 10px 0;
      margin: 10px 0;
      align-items: center;
      margin-right: 40px;
      cursor: default;
      user-select: auto;
    }
    .name {
      width: 130px;
    }
    .amount {
      flex: 2;
      margin-right: 40px;
      color: #606266;
      .num {
        color: #ea5728;
        font-weight: 500;
      }
    }
    .amount.uni{
      flex: none;
    }
    .offline-item {
      line-height: 36px;
      color: #626262;
    }
    .offline-tip {
      line-height: 34px;
      color: #9e9e9e;
    }
  }
  .lay-password {
    .form-item-password {
      margin-bottom: 0;
      .el-form-item__label {
        font-size: 15px;
        color: #3f3f3f;
      }
      .el-input {
        width: auto;
      }
      .el-input__inner {
        width: 200px;
      }
      .password_prompt {
        color: #f56c6c;
        line-height: initial;
        margin-top: 5px;
      }
    }
    .forget {
      margin-left: 3px;
      color: #3487dd;
      cursor: pointer;
    }
  }
  .lay-remark {
    padding-left: 0 !important;
    margin-left: -5px;
    border: none;
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .lay-footer {
    padding: 0;
    text-align: center;
    .btn-pay {
      width: 200px;
    }
    .btn-pay-note{
      margin-top: 5px;
      margin-left: 125px;
    }
  }
}
@media screen and (max-width: 1360px) {
  .order-payment {
    .ICP {
      .card {
        .card_box {
          width: 90%;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.nextStepFixed{
  position: absolute;
  top: 0;
  left: 0;
  right:0;
  bottom: 0;
  z-index: 10;
  background-color: #fff;
}
.contentAbsFixed {
  position: absolute;
  top: 0;
  left: 0;
  right:0;
  bottom: 0;
  z-index: 10;
}
.order-payment-dialog{
  :deep(.el-dialog) {
    height: 724px;
    overflow: hidden;
  }
}
.bankTo, .yeepaycode{
  display: flex;
  flex-direction: column;
  justify-content: center;
  .tip1{
    color: @icColor;
    padding: 3px 0;
  }
  .tip2 {
    padding: 3px 0;
    span{
      color: @icColor;
    }
  }
  ul{
    margin-top: 2px;
    li{
      display: flex;
      align-items: center;
      width: 50%;
      justify-content: space-between;
      padding: 6px 0;
      .msg{
        display: flex;
        align-items: center;
      }
      .copy{
        cursor: pointer;
      }
      .label{
        width: 76px;
        text-align: right;
      }

    }
  }
}
.wangyin{

  .toBPay{
    margin: 10px 0;
    font-size: 18px;
    color:#303133;
    font-weight: 700;
  }
  ul{
    display: flex;
    flex-wrap: wrap;
    li{
      flex-basis: calc(20% - 20px);
      .pointerBox{
        display: flex;
        align-items: center;
        padding: 6px 12px;
        cursor: pointer;
        width: 122px;
        justify-content: space-between;
        position: relative;
        border: 1px solid transparent;
        &.active:after {
          content: url(~/common/assets/img/select.png);
          position: absolute;
          top: 0;
          right: -4px;
          transform: scale(0.8);
          transform-origin: top left;
        }
        &.active{
          border: 1px solid #ea5728;
        }
        margin: 7px 0;
      }
      img{
        width: 30px;
        height: 30px;
      }
      span{
        font-size: 16px;
        color: #303133;
      }
    }
  }
}
</style>
